import cors from 'cors'
const whitelist = ['http://localhost:3030', 'http://localhost:3001']

export const cors_middleware = cors({
  origin: function (origin: any, callback) {
    if (whitelist.indexOf(origin) !== -1 || !origin) {
      callback(null, true) // allowed
    } else {
      const msg =
        'The CORS policy for this site does not allow access from the specified Origin.'
      return callback(new Error(msg), false)
    }
  },
  credentials: true,
  methods: ['GET', 'POST', 'PUT', 'DELETE', 'OPTIONS'],
})
